import React from 'react'
import { sections } from './Dashboard'
import { Link } from 'react-router-dom'
import '../style/Courses.scss';
export default function Courses() {
    return (
        <section id="courses" className="educational-directions">
            <h2>Մեր դասընթացները</h2>
            <div className="categories-grid">
                {sections.map((course) => (
                    <Link to={`/${course.id}`} key={course.id} className="course-card">
                        <span className="icon">{course.icon}</span>
                        <h3>{course.title}</h3>
                        <p>{course.desc}</p>
                        <span className="more-link">Իմանալ ավելին </span>
                    </Link>
                ))}
            </div>
        </section>
    )
}
